import React, { useContext, useEffect, useState } from "react";
import HeaderbarHome from "../../components/Genericos/HeaderbarHome/HeaderbarHome";
import Sidebar from "../../components/Genericos/Sidebar/Sidebar";
import MultitabAtencionSinTurno from "../../components/Turnos/MultitabAtencionSinTurno/MultitabAtencionSinTurno";
import { wsGetCentros } from "../../context/Actions/atencionSinTurno/atencionSinTurno";
import { PortalContext } from "../../context/Provider";
import { multiTabsDataAtencionSinTurno } from "../../../global/utils/multiTabData";
import "./AtencionSinTurno.css";
import AtencionSinTurnoTituloTxt from "./AtencionSinTurnoTituloTxt";
import Dropdown from "../../components/Genericos/Dropdown/Dropdown";
import { setPasoMultitabSinTurno } from "../../context/Actions/multitabSinTurno/multitabSinTurno";
import BurguerMobile from "../../components/Genericos/BurguerMobile/BurguerMobile";
import Modal from "../../components/Genericos/Modal/Modal";
import { pageContainerVariants } from "global/utils/cardAnimation";
import { motion } from "framer-motion";
import HeaderTitle from "_+_Portal/components/Genericos/HeaderTitle/HeaderTitle";

const AtencionSinTurno = () => {
  const {
    atencionSinTurnoDispatch,
    multitabSinTurnoState,
    multitabSinTurnoDispatch,
    atencionSinTurnoState,
    modalState,
  } = useContext(PortalContext);
  const [showBurguerMobile, setShowBurguerMobile] = useState(false);
  const [
    placeholderDropdownAtencionSinTurno,
    setplaceholderDropdownAtencionSinTurno,
  ] = useState(multiTabsDataAtencionSinTurno[0].nombreBase + " (0)");
  const widthWindow = window.innerWidth;
  const esMobile = widthWindow <= 768;

  // Tabs con conteo dinámico según datos de centros del API
  const dataCentros = atencionSinTurnoState?.atencionSinTurno?.data;
  const tabsConConteo = React.useMemo(() => {
    const list = Array.isArray(dataCentros) ? dataCentros : [];
    return multiTabsDataAtencionSinTurno.map((tab) => ({
      ...tab,
      nombre: `${tab.nombreBase} (${list.filter((item) => item.tipoTexto === tab.tipoTexto).length})`,
    }));
  }, [dataCentros]);
  
  const onShowBurguerHandle = () => {
    setShowBurguerMobile(true);
  };

  const onCloseBurguerMobile = (type) => {
    if (type === "open") setShowBurguerMobile(true);
    else setShowBurguerMobile(false);
  };

  const onChangeDropdownMobile = (e) => {
    if (e !== "") {
      setPasoMultitabSinTurno(e.id)(multitabSinTurnoDispatch);
      setplaceholderDropdownAtencionSinTurno(e.nombre);
    }
  };

  useEffect(() => {
    wsGetCentros()(atencionSinTurnoDispatch);
  }, []);

  // Sincronizar placeholder del dropdown con el tab activo y el conteo actual
  useEffect(() => {
    const paso = multitabSinTurnoState?.multitabSinTurno?.paso;
    if (typeof paso === "number" && tabsConConteo[paso]) {
      setplaceholderDropdownAtencionSinTurno(tabsConConteo[paso].nombre);
    }
  }, [multitabSinTurnoState?.multitabSinTurno?.paso, tabsConConteo]);

  return (
    <React.Fragment>
      {modalState.modal.show && <Modal />}
      {/* HEADER BAR DE PORTAL  */}
      <BurguerMobile
        onCloseBurguerMobile={onCloseBurguerMobile}
        showBurguerMobile={showBurguerMobile}
      />

      <HeaderbarHome onShowBurguerHandle={onShowBurguerHandle} />
      <HeaderTitle title={"Atención Sin Turno"} />

      <div className="ptur-bodyContainer-atencionSinTurno">
        <Sidebar />
        <motion.div
          variants={pageContainerVariants(esMobile)}
          initial="hidden"
          animate="visible"
          exit="exit"
          className={"ptur-atencionSinTurno-mainBody"}
        >
          <div className="ptur-atencionSinTurno-containerUno">
            <AtencionSinTurnoTituloTxt />
            <div className="ptur-atencionSinTurno-dropdownMobile">
              <Dropdown
                valor={multitabSinTurnoState.multitabSinTurno.paso}
                datos={tabsConConteo}
                campoCodigo="id"
                descripcion="nombre"
                onChange={onChangeDropdownMobile}
                placeholder={placeholderDropdownAtencionSinTurno}
              />
            </div>
            <div className="ptur-atencionSinTurno-cuerpo">
              <div className="ptur-atencionSinTurno-multitab">
                <MultitabAtencionSinTurno
                  tabs={tabsConConteo}
                />
              </div>
            </div>
          </div>
        </motion.div>
      </div>
    </React.Fragment>
  );
};

export default AtencionSinTurno;
